import { Dialog, Transition } from '@headlessui/react'
import { XIcon } from '@heroicons/react/outline'
import Button from 'components/forms/Button'
import { Fragment, useState } from 'react'
import ServiceForm from './ServiceForm'

const ServiceSuggestPopup = () => {
  const [isOpen, setIsOpen] = useState(false)
  return (
    <>
      <div className='mt-4 px-6 lg:px-8 bg-lightGrey shadow-inner h-[90px] w-full flex justify-between items-center rounded-xl'>
        <div className='font-unbounded font-bold leading-snug text-dark uppercase text-sm md:text-base'>
          Хотите сделать заказ?
        </div>
        <Button
          className='btn-primary text-sm w-1/2 md:w-1/3'
          onClick={() => setIsOpen(true)}
        >
          Оформить заявку
        </Button>
      </div>

      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog
          as='div'
          className='fixed z-60 inset-0 overflow-y-auto'
          onClose={setIsOpen}
        >
          <div className='flex items-end justify-center min-h-screen text-center sm:block'>
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0'
              enterTo='opacity-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'
            >
              <Dialog.Overlay className='fixed inset-0 bg-dark bg-opacity-75 transition-opacity' />
            </Transition.Child>

            <span
              className='hidden sm:inline-block sm:align-middle sm:h-screen'
              aria-hidden='true'
            >
              &#8203;
            </span>

            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
              enterTo='opacity-100 translate-y-0 sm:scale-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100 translate-y-0 sm:scale-100'
              leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            >
              <div className='inline-block align-bottom bg-lightGrey px-4 md:px-6 lg:px-8 xl:px-9 pt-8 pb-10 text-left shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-[80%] lg:max-w-[60%] sm:px-6 sm:py-8 w-full'>
                <button
                  aria-label='Закрыть'
                  type='button'
                  className='absolute top-6 right-6 focus:outline-none z-10'
                  onClick={() => setIsOpen(false)}
                >
                  <XIcon
                    className='h-6 w-6 text-dark lg:hover:text-accent'
                    aria-hidden='true'
                  />
                </button>

                <ServiceForm />
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  )
}

export default ServiceSuggestPopup
